import { useCart } from '@chordcommerce/gatsby-theme-autonomy'
import { useEffect } from 'react'
import React from 'react'
import useLocaleCartLogic from '~/utils/intl/context/hooks/use-locale-cart-logic'

export function useUpsell(items) {
  const [upsellItems, setUpsellItems] = React.useState(
    (items || []).slice(0, 3),
  )
  const { cart, isFetching } = useLocaleCartLogic()

  function sortItems() {
    setUpsellItems(() => {
      if (isFetching) {
        return items.slice(0, 3)
      }

      const productSlugs = (cart?.lineItems || []).map(
        item => item.variant.slug,
      )
      // remove upsell item that is associated with the bundle
      // Cheddy 6-Pack ~~~ Cheddy 6-Pack Bundle
      const bundleSku = (cart?.lineItems || [])
        .filter(item => !!item.isBundle)
        ?.map(item => item.variant.sku)
      return items.filter(
        item =>
          !productSlugs.includes(item.product[0].slug) &&
          !bundleSku.includes(item?.usePreFilledBundle?.masterSku),
      )
    })
  }

  useEffect(() => {
    sortItems()
  }, [items, cart?.lineItems])

  return upsellItems
}
